import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=d2cef4ce&"
import script from "./pricing.vue?vue&type=script&lang=js&"
export * from "./pricing.vue?vue&type=script&lang=js&"
import style0 from "./pricing.vue?vue&type=style&index=0&id=d2cef4ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoCloud: require('/home/lewis/actions-runner/_work/EchoWaveLunar/EchoWaveLunar/components/global/LogoCloud.vue').default})
